import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import Typography from '../../Typography';

function FormToast({ children, className, classes, ...other }) {
  return (
    <div className={classNames(classes.root, className)} {...other}>
      <Typography className={classes.text} type="caption">
        {children}
      </Typography>
    </div>
  );
}

FormToast.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
};

FormToast.defaultProps = {
  className: null,
  children: null,
};

const stylesheet = theme => ({
  root: {
    backgroundColor: theme.palette.error[500],
    maxHeight: 250,
    padding: [[theme.spacing.small, theme.spacing.large]],
    animation: `toast-in ${theme.transitions.duration.complex}ms`,
  },
  text: {
    color: theme.palette.common.white,
  },
  '@keyframes toast-in': {
    '0%': {
      maxHeight: 0,
    },
    '100%': {
      maxHeight: 250,
    },
  },
});

export default injectSheet(stylesheet)(FormToast);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/FormToast/FormToast.js